import React, { useEffect } from "react";

import PageSection from "../SubComponents/PageSectionLeft";
import HinduismImg from "../Assets/9-min.jpg";

import ReactPlayer from "react-player";
const Hinduism = () => {
  const description = `### सनातन धर्म - एक जीवन शैली

  हिंदू धर्म, या वेदांत की मौलिक शिक्षा यह है कि मनुष्य का मूल स्वभाव शरीर या मन तक ही सीमित नहीं है। इन दोनों से परे प्रत्येक आत्मा के भीतर परमात्मा का अंश है। मैं इसी आध्यात्मिक मार्ग का अनुयायी हूं।
  
  हिंदु को धर्म इस वजह से कहते है की यहाँ प्रत्येक मनुष्य का हर एक के प्रति धर्म है पिता धर्म, पुत्र धर्म, भाई धर्म अर्थात् कर्तव्य ।। यह जीवनशैली का केंद्र बिंदु है हिन्दू सिद्धांत से प्राप्त संस्कार मेरे जीवन का अभिन्न अंग हैं और मुझे जीवन के हर क्षेत्र में विशिष्ट कार्य करने की प्रेरणा देते हैं।
   
  मेरे संपूर्ण  जीवन की उपलब्धियों में, मुझे इस बात पर सर्वाधिक गर्व है कि मुझे हनुमान जी ने शिमला के प्रसिद्ध जाख़ू मंदिर में, विश्व की सबसे ऊंची १०८ फुट प्रतिमा बनाने का सौभाग्य दिया।
  
  ### संस्कार ही है सभ्य समाज का आईना।

  विद्या, तप, दान, शील, गुण और धर्म सभ्य समाज का दर्पण हैं।

येषां न विद्या न तपो न दानं ज्ञानं न शीलं न गुणो न धर्मः ! ते मर्त्यलोके भुविभारभूता मनुष्यरूपेण मृगाश्चरन्ति !! जिन लोगो के पास विद्या, तप, दान, शील, गुण और धर्म नहीं होता. ऐसे लोग इस धरती के लिए भार है और मनुष्य के रूप में जानवर बनकर घूमते है।

एक मजबूत समाज बनाने के लिए, हिंदू धर्म के विभिन्न धार्मिक ग्रंथों में बताए गए नैतिक और सामाजिक दिशा-निर्देशों का पालन करते हुए प्रत्येक हिंदू का समाज के प्रति कर्तव्य है जिससे हर व्यक्ति इस समाज में सामंजस्य बनाए रखेगा।
 `;

  const description2 = ` 
  ### धर्म और कर्म

  धर्म और कर्म  हर हिंदु के अभिन्न अंग है। हमारे विचारों, शब्दों और कर्मों के माध्यम से एक-दूसरे पर जो सीधा प्रभाव पड़ता है, वह अंततः उस मार्ग को बनाता है जिसका हम अनुसरण करते हैं। कर्म का स्थायी चक्र धर्म के आधार पर चुनाव करने का परिणाम है। 
  
  ### कर्म में धर्म है।
  
  सदाचार, सही आचरण, और नैतिकता एक सफल जीवन के लिए महत्वूर्ण हैं और खुशी पाने के लिए व्यक्ति को निस्वार्थ सेवा करनी चाहिए। दूसरों की मदद करना, करुणा का अभ्यास करना और अहिंसा का पालन करना धर्म की असली अभिव्यक्ति है परन्तु अन्याय के ख़िलाफ़ हिंसा और जंग मान्य है । मैं मानता हूं कि सकारात्मक क्रियाएं सकारात्मक प्रभाव पैदा करती हैं; नकारात्मक क्रियाएं नकारात्मक प्रभाव उत्पन्न करती हैं। इसलिए यथासंभव सकारात्मक सोच और कार्य में अधिक से अधिक समय लगायें। 
  
  ### हनुमान जी की भक्ति
   
  “गुरु के चरणों की धूल से, मैं अपने मन के दर्पण को साफ करता हूं और फिर श्री राम चंद्र की पवित्र महिमा को सुनाता हूं; रघु वंश के बीच सर्वोच्च जो इच्छाओं को अनुदान देता है”
   
  हनुमान चालीसा की ये शुरूआती पंक्तियाँ भगवान राम के प्रति हनुमानजी की भक्ति और समर्पण को प्रमाणित करती हैं।
   
  जिस प्रकार भगवान हनुमान जी का जीवन प्रभु श्री राम को समर्पित था,  मेरा जीवन बजरंगबली को समर्पित है। हनुमानजी मेरे जीवन के सभी उतार चढाव में मेरे मार्गदर्शक रहें हैं। हनुमानजी की शक्ति और साहस के प्रति उनके रुद्र रूप को हिंदुस्तान के हर व्यक्ति को दिखाने के लिए मुझे सौभाग्यावश हनुमान जी ने चुना, के मैं शिमला में जाख़ू मंदिर के प्रांगण में हनुमानजी की दुनिया की सबसे ऊंची १०८ फ़ीट ऊँची प्रतिमा बनाकर उनके आशीर्वाद के लिए एक विनम्र योगदान का भागी बनूँ।  यह प्रतिमा ब्राजील के रियो डी जेनेरियो में क्राइस्ट द रिडीमर की प्रतिमा से ऊंची है। आज, यहाँ हर महीने हजारों भक्त हनुमानजी का आशीर्वाद लेने के लिए आते हैं। हमारे स्वर्गवासी पिताजी श्के नाम स्थापित ट्रस्ट श्री एच o सी o नंदा ट्रस्ट द्वारा निर्मित, हनुमान जी की प्रतिमा 108 फीट ऊंची और 8100 फीट पहाड़ी पर स्थित है, जो बिना बादल के आकाश में १०० किलॉमेटर तक से दिखाई देती है ।
   
  हनुमानजी, अपने सर्वगुण स्वरूप में हिंदू युवाओं के लिए एक महान आदर्श हैं,  हनुमान जी की बुद्धि, शारीरिक शक्ति और भक्ति एक उच्च एवं विशिष्ट जीवन का मूल मंत्र है।
   
  उनके आशीर्वाद से, एच o सी o एन o ट्रस्ट ने देश के प्रत्येक दिशा में हनुमानजी की १०८ फ़ुट ऊँची मूर्ति के निर्माण कार्य का संकल्प लिया  है। इस शृंखला में पश्चिम दिशा में “मोरबी-गुजरात” में मूर्ति का कार्य तीव्र गति से प्रगतिशील है और जनवरी २०२१ तक सम्पूर्ण होने की सम्भावना है ।
  
  दक्षिण में रामेश्वरम में भूमि अधिग्रहण का कार्य सम्पूर्ण हो गया है और मूर्ति निर्माण के लिए राज्य सरकार की अनुमति भी मिल गयी है । पूर्वी दिशा में भूमि अधिग्रहण का कार्य प्रगतिशील है, और उम्मीद है यह सब कार्य वर्ष २०२१ में सम्पूर्ण हो जाएँगे ।
 
  `;

  const description3 = `
  ### Sanskaar - A way of Life 

  The fundamental teaching of Hinduism, or Vedanta, is that the basic nature of man is not limited to body or mind. Beyond these two lies the part of the divine within each soul. I am follower and believer of this spiritual path.

  Every Hindu has a set of duties towards his family, society and nation and these duties have to fulfilled with a certain set of principles that can be termed as Sanskar. 
  
  Sanskar derived from Hindu ideology and our history is an integral part of my life and a motivation for me to do outstanding work in every sphere of life. It is the backbone of every achievement I have had in life and continues to direct my life meaningfully, and feed my strive for excellence

  ### Sanskar – A mirror to Society

  In order to build a strong society It is imperative for every Hindu to be a contributing part of society and follow the moral, societal and ethical guidelines as charted out in the various religious texts of Sanatan Dharm.
  

### Dharma and Karma
Hinduism is an all-encompassing term that has Dharma and Karma as its essence. Virtue, right conduct, ethics and morality are integral to Dharma. Acting appropriately is the simple imperative of all the moral and ethical codes that I follow while striving for a life streamlined with the ideology that positive actions produce positive effects; negative actions produce negative effects.


### My Devotion to HanumanJi

Of all achievements, I am most proud of the fact that I was chosen by Hanumanji to build his tallest statue in the world at the famous Jhakoo Temple in Shimla.
  
With the dust of the Guru's feet, I clean the mirror of my mind and then narrate the sacred glory of Sri Ram Chandra; the supreme among the Raghu dynasty who grants wishes.

These opening lines of Hanuman Chalisa surmise the devotion, dedication and submission of HanumanJi towards Lord Rama.

On similar lines, my life is dedicated and devoted to Bajrangbali. He has been a guiding light through thick and thin, ups and downs, happiness and sorrow. As a mark of respect towards HanumanJi's strength and courage, I made a humble contribution for his blessing by building the world's tallest statue of Hanumanji next to Jhakoo temple in Shimla. The statue stands taller than the statue of Christ the Redeemer at Rio De Janeiro, Brazil. Today, it is visited by thousands of devotees every month who come to the place to seek HanumanJi's blessings. Built by the HC Nanda Trust, Hanuman Ji's statue is 108 feet tall and located at an altitude of 8100 feet, making the reinforced concrete idol the highest in the world visible from several kilometres on a clear sky day.

HanumanJi is an idol to follow for the Hindu youth with his many virtues that include his courage, bravery, strength, wisdom, intelligence and simplicity. Hanuman Ji's perfect mix of intelligence, physical strength and devotion is the mantra for making it big in life.   Inspired and guided by His blessings, HCN trust plans to build three more idols of HanumanJi in each of the four corners of the country. The work of land acquisition in Rameswaram in the south has been completed and the permission of the state government has also been received for the construction of the idol. Land acquisition in east India is under progress, and it is expected that it will be completed in the year 2021.



  `;
  useEffect(() => {
    window.scrollTo(0, 0);
  });
  return (
    <React.Fragment>
      <div className="section-top-right">
        <h4 className="section-top-heading">SANSKAR - WAY OF LIFE</h4>
        <div style={{ color: "#2c3e50" }}>
          "A way of leading life, Sanskar (direction of Hindu dharma) is more than just a guiding light, it is the essence of being that determines life, from daily routine to major business decisions, adherence to sanskar is essential for a meaningful existence, and to leave a mark on society."
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-sm-4 SmallSizeDiv">
          <img src={HinduismImg} alt="Hinduism" className="InsideImagesRight" />
        </div>
        <div className="col-12 col-sm-6">
          <PageSection description={description} />
          <img
            src={HinduismImg}
            alt="Hinduism"
            className="InsideImagesRight2"
          />
          <PageSection description={description2} />
        </div>
        <div className="col-12 col-sm-6">
          {/* <img src={HinduismImg} alt="Hinduism" className="InsideImagesRight2" /> */}
          <ReactPlayer
            url="https://firebasestorage.googleapis.com/v0/b/nikhil-nanda.appspot.com/o/hind.mp4?alt=media&token=41a66938-9c40-4ddf-b373-c46ed22ff327"
            playing={true} //autoplay
            controls
            width="100%"
            style={{ margin: "10px" }}
          />
          <PageSection description={description3} />
        </div>

        {/* <ReactPlayer
          url="https://firebasestorage.googleapis.com/v0/b/nikhil-nanda.appspot.com/o/hind.mp4?alt=media&token=41a66938-9c40-4ddf-b373-c46ed22ff327"
          playing={true} //autoplay
          controls
          width="100%"
          style={{ margin: "40px" }}
        /> */}
      </div>
    </React.Fragment>
  );
};

export default Hinduism;
